import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const RootCauseClassificationService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/ComplaintRootCause",
      top: "1",
      filter: `Code eq '${code}'`,
      select: ["RecordId", "Code", "Description", "SortOrder", "IsDefault", "Inactive", "DateCreated", "CreatedBy", "DateChanged", "ChangedBy"],
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(mode, payload, recordId) {
    if (mode === "create") {
      return await ApiService.post("api/ComplaintRootCause", payload, "Guid");
    } else {
      return await ApiService.patch("api/ComplaintRootCause", `guid'${recordId}'`, payload, "String");
    }
  },

  async saveDefault(recordId) {
    var url = "api/ComplaintRootCause/SaveDefault";
    return await ApiService.post(url, { RecordId: recordId }, "Guid");
  },

  async getAll() {
    return await ApiService.get(
      "api/ComplaintRootCause?$orderby=SortOrder asc&$select=Code,Description,IsDefault&$filter=Inactive eq 'N'"
    );
  },

  dataSourceConfig(params) {
    return ApiService.createDataSource("api/ComplaintRootCause", params);
  },
};

export { RootCauseClassificationService };
